





































































































import Vue from "vue";
import MilestoneCell from "@/modules/milestone-planner/components/milestone-cell/milestone-cell.vue";
import MilestoneTooltip from "@/modules/milestone-planner/components/milestone-tooltip/milestone-tooltip.vue";
import {
  IGridCategory,
  IGridMilestone,
} from "@/modules/milestone-planner/components/milestones-grid/milestones-grid.interface";
import { IAssessmentLevel } from "@/services/data/assessment/assessment.interface";
import MilestoneCarouselDescription from "@/modules/milestone-planner/components/milestone-carousel/milestone-carousel-description.vue";
import GridLevels from "@/modules/milestone-planner/components/grid-levels/grid-levels.vue";
import {
  TMilestoneDetailsTab,
  MILESTONE_DETAILS_TABS,
} from "@/modules/milestone-planner/services/data/milestones/milestone.interface";
import {
  ROUTE_MILESTONE_PLANNER_DETAIL_VISITORS,
  ROUTE_MILESTONE_PLANNER_DETAIL,
} from "@/modules/milestone-planner/services/router/routes-names";

export default Vue.extend({
  name: "MilestoneCarousel",

  components: {
    MilestoneCell,
    MilestoneCarouselDescription,
    GridLevels,
    MilestoneTooltip,
  },

  props: {
    categories: {
      type: Array as () => IGridCategory[],
      required: true,
    },

    levelsCount: {
      type: Number,
      required: true,
    },

    selectedCategory: {
      type: Object as () => IGridCategory,
      required: true,
    },

    lastAssessmentData: {
      type: Array as () => IAssessmentLevel[],
      required: true,
    },

    isVisitor: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentPosition: 1,
      selectedMilestone: null as IGridMilestone | null,
    };
  },

  computed: {
    currentLevel(): number | null {
      const categoryLevelData = this.lastAssessmentData.find(
        (data) => data.category === this.currentCategory?.id,
      );

      return categoryLevelData?.level ? categoryLevelData.level : 1;
    },

    currentCategory(): IGridCategory | undefined {
      return this.categories.find(
        (category) => category.order === this.currentPosition,
      );
    },
  },

  mounted() {
    this.currentPosition = this.selectedCategory.order;
  },

  methods: {
    // We have to add one to the position because the category order property starts at 1
    changeCarouselPosition(index: number) {
      this.currentPosition = index + 1;
      this.$emit(
        "change-category-level",
        this.currentCategory,
        this.currentLevel,
      );
    },

    changeRightItemTransformStyles(categoryOrder: number): boolean {
      return (
        categoryOrder === this.currentPosition + 1 ||
        (categoryOrder === 1 && this.currentPosition === this.categories.length)
      );
    },

    changeLeftItemTransformStyles(categoryOrder: number): boolean {
      return (
        categoryOrder === this.currentPosition - 1 ||
        (categoryOrder === this.categories.length && this.currentPosition === 1)
      );
    },

    /**
     * Check if provided milestone shall be blurred. It shall be blurred
     * when there's a selected milestone which is not the provided one.
     *
     * @param {IGridMilestone} milestone
     */
    isMilestoneBlurred(milestone: IGridMilestone) {
      return !!this.selectedMilestone && this.selectedMilestone !== milestone;
    },

    /**
     * Mark a milestone as selected when its tooltip gets shown.
     *
     * @param {IGridMilestone} milestone
     */
    onTooltipShow(milestone: IGridMilestone) {
      setTimeout(() => {
        this.selectedMilestone = milestone;
      });
    },

    /**
     * Clear selected milestone when a milestone's tooltip gets hidden.
     */
    onTooltipHide() {
      this.selectedMilestone = null;
    },

    /**
     * Handle milestone plan button clicks,
     * redirecting to plan tab on milestone detail page.
     *
     * @param {number} categoryId
     * @param {number} level
     */
    onMilestonePlanClick(categoryId: number, level: number) {
      this.goToMilestoneDetail(categoryId, level, MILESTONE_DETAILS_TABS.PLAN);
    },

    /**
     * Handle milestone complete button clicks,
     * redirecting to complete tab on milestone detail page.
     *
     * @param {number} categoryId
     * @param {number} level
     */
    onMilestoneCompleteClick(categoryId: number, level: number) {
      this.goToMilestoneDetail(
        categoryId,
        level,
        MILESTONE_DETAILS_TABS.COMPLETE,
      );
    },

    /**
     * Navigate to provided tab of milestone detail page.
     *
     * @param {number} categoryId
     * @param {number} level
     * @param {TMilestoneDetailsTab} tab
     */
    goToMilestoneDetail(
      categoryId: number,
      level: number,
      tab: TMilestoneDetailsTab,
    ) {
      this.$router.push({
        name: this.isVisitor
          ? ROUTE_MILESTONE_PLANNER_DETAIL_VISITORS
          : ROUTE_MILESTONE_PLANNER_DETAIL,
        params: {
          categoryId: categoryId.toString(),
          levelValue: level.toString(),
        },
        query: { tab },
      });
    },
  },
});
